import type { NamingJob } from '../renderer/NamingWindow';
import { ExportHistoryCard } from './ExportHistoryCard';
import { ExportTimingCard } from './ExportTimingCard';
import { FileNamingCard } from './FileNamingCard';
import { RetentionCard } from './RetentionCard';
import { SendResultsCard } from './SendResultsCard';

/**
 * The job setup's Export section in Paige: the job's destinations, how every destination names
 * what it files (CapturePoint's file naming, one per job), and retention, in place of
 * CapturePoint's export card (a folder on the operator's computer or a saved connection, with
 * filing, timing and recovery), which the desktop keeps (docs/engineering/workbench-port.md, "What
 * Paige hides from the desktop workbench and why"). `job` is the job setup's own definition.
 */
export function PaigeExportSetup({ job }: { job?: NamingJob }) {
  return (
    <>
      <header className="setup-export-heading">
        <h2>Export</h2>
        <p>
          Where confirmed documents go, when they leave, how they are named, and how long Paige
          keeps them after.
        </p>
      </header>
      <div className="paige-export-setup" aria-label="Export">
        <SendResultsCard />
        <ExportTimingCard />
        <ExportHistoryCard />
        <FileNamingCard job={job} />
        <RetentionCard />
      </div>
    </>
  );
}
